import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetRelationalShipBO } from './client-employee-relationship.modal';
@Injectable({
  providedIn: 'root'
})
export class RelationshipDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(GRState: GetRelationalShipBO): void {
    this.getRelationship(GRState).subscribe(x => super.next(x));
  }
  getRelationship(GRState?: GetRelationalShipBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployerEmployeeRelationship/GetEERelationship?", GRState)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}
